import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Icon from '../core/Icon';
import placeholders from '../data/placeholders';
import DataItem from '../data/Item';
import LinkFormatter from './Link';
import Placeholders from './Placeholders';
/**
 *  @param {import('./types').DataLinkFormatter } props
 */

var DataLinkFormatter = function DataLinkFormatter(_ref) {
  var dataType = _ref.dataType,
      id = _ref.id,
      data = _ref.data,
      hideIcon = _ref.hideIcon,
      rest = _objectWithoutProperties(_ref, ["dataType", "id", "data", "hideIcon"]);

  var linkProps = {};

  if (!hideIcon) {
    if (!data) {
      //wait for data to come so that icon updates
      linkProps.icon = React.createElement(DataItem, {
        dataType: dataType,
        id: id,
        cacheStrategy: "cache-only"
      }, function (_ref2) {
        var value = _ref2.value;
        return value ? React.createElement(Icon, {
          style: {
            fontSize: '1rem' // @ts-ignore

          },
          type: placeholders('{icon}', {
            dataType: dataType,
            id: id
          }, value)
        }) : null;
      });
    } else linkProps.icon = placeholders('{icon}', {
      dataType: dataType,
      id: id
    }, data);
  }

  linkProps.text = React.createElement(Placeholders, {
    template: "{label}",
    dataType: dataType,
    id: id,
    value: data
  });
  return React.createElement(LinkFormatter, Object.assign({}, rest, linkProps));
};

DataLinkFormatter.defaultProps = {
  hideIcon: false
};
export default DataLinkFormatter;